import script from "./CheckoutCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutCounter.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutCounter.vue?vue&type=style&index=0&id=a4bed79a&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4bed79a"]])

export default __exports__